import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getProducts({ commit }, { supplierId, params = {} } ) {
    return axios.get(`/suppliers/${supplierId}/products`, { params })
  },
  searchProducts({ commit }, { supplierId, params = {} } ) {
    return axios.get(`/suppliers/${supplierId}/products/search`, { params })
  },
  getProduct({ commit }, id) {
    return axios.get(`/products/${id}`)
  },
  createProduct({ commit }, data) {
    return axios.post('/products', data)
  },
  updateProduct({ commit }, data) {
    return axios.put(`/products/${data.id}`, data)
  },
  importProducts({commit}, params = {}) {
    const formData = new FormData()
    formData.append('file', params.file, params.file.name)
    formData.append('type', params.type)
    formData.append('force_save', params.force_save)
    formData.append('download_error', params.download_error)
    formData.append('supplier_id', params.supplierId)
    formData.append('mappingPerSheet', params.mappingPerSheet)
    const responseType = params.download_error ? 'blob' : 'json'
    return axios.post('/products/import', formData, {responseType: responseType})
  },
  importProductsValidation({commit}, params = {}) {
    const formData = new FormData()
    formData.append('file', params.file)
    formData.append('type', params.type)
    formData.append('force_save', params.force_save)
    formData.append('download_error', params.download_error)
    formData.append('supplier_id', params.supplierId)
    const responseType = params.download_error ? 'blob' : 'json'
    return axios.post('/products/import/base-validation', formData, {responseType: responseType})
  },
  exportProducts({ commit }, { supplierId, params = {} } ) {
    return axios.get(`/suppliers/${supplierId}/products/export`, { params: params, responseType: 'blob' })
  },
  downloadErrorReport({ commit }, params = {}) {
    return axios.get(`/import/${params.url}/download-errors`, {responseType: 'blob'})
  },
  downloadImportProductsTemplate({ commit }, params = {}) {
    return axios.get(`/import/product/download-template`, {responseType: 'blob'})
  },
}
